import { atom } from "jotai";
import { sideBarSelectedAtom } from "./sideBarSelectedAtom";

/** Not used for copilot!
 * For copilot states, use OUR OWN useCopilotDrawerState - NOT the one from ai-toolkit/client - (in a component)
   or copilotDrawerStateAtom (in another atom)
 */
export const closeSidebarSetter = atom(null, (_, set) => {
  set(sideBarSelectedAtom, null);
});

closeSidebarSetter.debugLabel = "closeSidebarSetter";
